import { http } from './http_service';

export function documentRemove(id){
    return http().post(`/client-document/remove/${id}`);
}

//Document Add Or Update AliasName
export function documentAddOrUpdateAliasName(id, data){
    return http().put(`/client-document/document-add-or-update-alias-name/${id}`, data);
}